import { type ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { theme } from '@side/pantry';

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};
